package pl.finn.forms.utils

class ControlType {

  val controlTypeMap = mutableMapOf(
    "ADDRESS" to ".*",
    "ANNEX" to ".*",
    "ANNEX_PWPW" to ".*",
    "ANY" to ".*",
    "ANY_TYPE" to ".*",
    "BOOLEAN" to ".*",
    "CZAS" to "[a-zA-Z0-9]{1,65}",
    "DATE" to "[a-zA-Z0-9]{1,255}",
    "E_MAIL" to "^[\\w!#$%&'*+/=?`{|}~^-]+(?:\\.[\\w!#$%&'*+/=?`{|}~^-]+)*@(?!-)(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$",
    "HTML" to ".*",
    "NIP" to "\\d{10}",
    "NUMBER" to "[0-9]{1,65}",
    "MSZKIIP" to ".*",
    "ORSIP" to ".*",
    "PESEL" to "\\d{11}",
    "PKD_2007" to ".*",
    "REGON" to "\\d{14}|\\d{7}|\\d{9}",
    "YEAR" to "[1-2][0-9][0-9]{2}",
    "A_CITY" to ".*",
    "A_STREET" to ".*",
    "A_NUMBER" to "\\S{0,4}|\\S{0,4}/\\S{0,4}"
  )

  open fun getPattern(name: String?): String? {
    if (name != null && !controlTypeMap[name].isNullOrEmpty()) {
      return controlTypeMap[name]
    }
    return ".*"
  }
}